//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MobilePanelClientTranslationsQuery: any = {
    GetListMobilePanelClientTranslations: Backofficebff + '/v1/mobilepanelclienttranslations/client-translation-list',
    GetSupportedCulturesByCountryId: Backofficebff + '/v1/mobilepanelclienttranslations/get-supported-cultures',
};
